import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Icon } from "semantic-ui-react";
import { getOfficeMimeTypes } from "../utils/mimetypes";

interface ICameraInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isMobile: boolean;
}

export const CameraInput = ({ onChange, isMobile }: ICameraInputProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);
  const [acceptString, setAcceptString] = useState("");

  useEffect(() => {
    const officeTypes = getOfficeMimeTypes();
    const allTypes = [...officeTypes, "image/*", "video/*", "application/pdf"];
    setAcceptString(allTypes.join(", "));
  }, []);

  const handleFileClick = () => {
    if (!fileInputRef.current) return;
    fileInputRef.current.click();
    fileInputRef.current.value = ""; // Reset the input value
  };

  const handleCameraClick = () => {
    if (!cameraInputRef.current) return;
    cameraInputRef.current.click();
    cameraInputRef.current.value = ""; // Reset the input value
  };

  enum FileAction {
    TakePhoto = "takePhoto",
    ChoosePhoto = "choosePhoto",
  }

  const handleMobileOption = (option: string) => {
    if (option === FileAction.TakePhoto) {
      handleCameraClick();
    } else if (option === FileAction.ChoosePhoto) {
      handleFileClick();
    }
  };

  const mobileOptions = [
    { key: FileAction.TakePhoto, text: "Take Photo", value: FileAction.TakePhoto, icon: "camera" },
    { key: FileAction.ChoosePhoto, text: "Choose from Library", value: FileAction.ChoosePhoto, icon: "image" },
  ] as const;

  // Both inputs are necessary. The first uploads from library and the second launches the camera.
  return (
    <>
      <input
        ref={fileInputRef}
        type='file'
        id='attachment'
        name='attachment'
        accept={acceptString}
        multiple
        onChange={(e) => onChange(e)}
        style={{ display: "none" }}
      />
      <input
        ref={cameraInputRef}
        type='file'
        id='camera'
        name='camera'
        accept={acceptString}
        capture='environment'
        onChange={(e) => onChange(e)}
        style={{ display: "none" }}
      />
      {isMobile ? (
        <Dropdown icon='camera' floating button className='icon'>
          <Dropdown.Menu>
            {mobileOptions.map((option) => (
              <Dropdown.Item {...option} key={option.key} onClick={() => handleMobileOption(option.value)} />
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Button icon onClick={handleFileClick}>
          <Icon name='paperclip' />
        </Button>
      )}
    </>
  );
};
